import React from 'react';

const HairdresserAssociationListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALONMANAGER', 'ROLE_SALONMANAGER_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/hairdressers/association',
      exact: true,
      component: React.lazy(() => import('./hairdressers_association'))
    }
  ]
};

const HairdresserStatsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/hairdresser/stats/:id',
      exact: true,
      component: React.lazy(() => import('./hairdresser_stats'))
    }
  ]
};

const HairdresserListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/hairdressers',
      component: React.lazy(() => import('./hairdressers_list'))
    }
  ]
};

const HairdresserImportHourConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/administration/prices',
      exact: true,
      component: React.lazy(() => import('./hairdresser_import'))
    }
  ]
};

const MassAdminBusinessHoursConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/administration/businesshours',
      exact: true,
      component: React.lazy(() => import('./massAdmin_businessHours'))
    }
  ]
};

const HairdresserTagsConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/administration/tags',
      exact: true,
      component: React.lazy(() =>
        import('./massAdmin_tags/hairdresser_tag_list')
      )
    }
  ]
};

const HairdresserMessagesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/administration/messages',
      exact: true,
      component: React.lazy(() =>
        import('./massAdmin_messages/hairdresser_message_list')
      )
    }
  ]
};

const MassAdminPicturesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/administration/pictures',
      exact: true,
      component: React.lazy(() => import('./massAdmin_pictures'))
    }
  ]
};

const HairdresserEditMinisiteConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    'ROLE_SALON',
    'ROLE_SALON_SHOW',
    'ROLE_SUPER_ADMIN',
    'FRANCHISEE_MINISITE_DASHBOARD'
  ],
  routes: [
    {
      path: '/hairdresser/minisite/:id',
      exact: true,
      component: React.lazy(() => import('./hairdresser_minisite'))
    }
  ]
};

const HairdresserDashboardMinisiteConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['FRANCHISEE_MINISITE_DASHBOARD'],
  routes: [
    {
      path: '/dashboard/minisite',
      exact: true,
      component: React.lazy(() =>
        import('./hairdresser_minisite/DashboardMinisite')
      )
    }
  ]
};

const HairdresserAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/hairdresser/add',
      exact: true,
      component: React.lazy(() => import('./hairdresser_edit'))
    }
  ]
};

const HairdresserEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/hairdresser/:id',
      exact: true,
      component: React.lazy(() => import('./hairdresser_edit'))
    }
  ]
};

export {
  HairdresserEditMinisiteConfig,
  HairdresserEditConfig,
  HairdresserStatsConfig,
  HairdresserAddConfig,
  HairdresserAssociationListConfig,
  HairdresserListConfig,
  HairdresserDashboardMinisiteConfig,
  HairdresserImportHourConfig,
  HairdresserTagsConfig,
  HairdresserMessagesConfig,
  MassAdminPicturesConfig,
  MassAdminBusinessHoursConfig,
};
